/**
 * QueueCard — shows queue position when delivery_queue_position > 1.
 * Renders instead of the live map until the order becomes next.
 */

const QUEUE_STRINGS = {
  pt: {
    title: "O seu pedido saiu para entrega",
    deliveriesBefore: (n) => `O estafeta tem ${n} entrega${n > 1 ? "s" : ""} antes da sua.`,
    eta: (m) => `Tempo estimado: ~${m} minutos`,
    note: "Quando o seu pedido for o próximo, activamos o mapa em tempo real.",
    nextTitle: "O seu pedido é o próximo!",
    nextNote: "O mapa em tempo real está a ser activado.",
  },
  es: {
    title: "Tu pedido salió para entrega",
    deliveriesBefore: (n) => `El repartidor tiene ${n} entrega${n > 1 ? "s" : ""} antes de la tuya.`,
    eta: (m) => `Tiempo estimado: ~${m} minutos`,
    note: "Cuando tu pedido sea el próximo, activaremos el mapa en tiempo real.",
    nextTitle: "¡Tu pedido es el próximo!",
    nextNote: "El mapa en tiempo real se está activando.",
  },
};

const styles = {
  card: {
    background: "#fff8e1",
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "12px",
    border: "1px solid #ffe082",
  },
  title: {
    fontWeight: 700,
    fontSize: "15px",
    marginBottom: "14px",
    color: "#1a1a1a",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "10px",
  },
  icon: { fontSize: "18px", marginTop: "1px", flexShrink: 0 },
  text: { margin: 0, fontSize: "14px", color: "#333" },
  note: {
    marginTop: "14px",
    fontSize: "12px",
    color: "#888",
    fontStyle: "italic",
  },
  nextCard: {
    background: "#e8f5e9",
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "12px",
    border: "1px solid #a5d6a7",
    textAlign: "center",
  },
  nextTitle: {
    fontWeight: 700,
    fontSize: "15px",
    color: "#2e7d32",
    marginBottom: "6px",
  },
  nextNote: { fontSize: "13px", color: "#555" },
};

export default function QueueCard({ tracking, lang = "es" }) {
  const position = tracking?.delivery_queue_position;
  const ordersBefore = Math.max(0, (position || 1) - 1);
  const eta = tracking?.estimated_delivery_minutes;
  const t = QUEUE_STRINGS[lang] || QUEUE_STRINGS.es;

  // Only render for active queue states
  if (!position || position === 0) return null;

  if (position === 1) {
    return (
      <div style={styles.nextCard} data-testid="queue-card-next">
        <p style={styles.nextTitle}>✅ {t.nextTitle}</p>
        <p style={styles.nextNote}>{t.nextNote}</p>
      </div>
    );
  }

  return (
    <div style={styles.card} data-testid="queue-card">
      <p style={styles.title}>{t.title}</p>

      {ordersBefore > 0 && (
        <div style={styles.row}>
          <span style={styles.icon}>📦</span>
          <p style={styles.text}>
            <strong>{t.deliveriesBefore(ordersBefore)}</strong>
          </p>
        </div>
      )}

      {eta > 0 && (
        <div style={styles.row}>
          <span style={styles.icon}>⏱</span>
          <p style={styles.text}>{t.eta(eta)}</p>
        </div>
      )}

      <p style={styles.note}>{t.note}</p>
    </div>
  );
}
